import { createSlice } from "@reduxjs/toolkit";
import { getAppData } from "../../lib/api";

const { actions, reducer } = createSlice({
  name: "general",
  initialState: {
    language: "de",
    idleMode: false,
    data: [],
    dataLoadingState: "idle",
  },
  reducers: {
    setLanguage(state, action) {
      state.language = action.payload;
    },
    enterIdleMode(state) {
      state.idleMode = true;
    },
    exitIdleMode(state) {
      state.idleMode = false;
    },
    dataLoading(state) {
      state.dataLoadingState = "pending";
    },
    dataReceived(state, action) {
      if (state.dataLoadingState === "pending") {
        state.dataLoadingState = "idle";
        state.data = action.payload;
      }
    },
  },
});

export const {
  setLanguage,
  enterIdleMode,
  exitIdleMode,
  dataLoading,
  dataReceived,
} = actions;

export const fetchData = () => async (dispatch) => {
  dispatch(dataLoading());
  const data = await getAppData();
  dispatch(dataReceived(data.data));
};

export default reducer;
